import {getPolicyAssignmentContractUrl} from '../../../url';
import PrintButton from '../ReactBootstrap/PrintButton';
import React from 'react';
import {printPolicyAssignmentContract} from '../../../print';
import PropTypes from 'prop-types';

const PolicyAssignmentContractPrintButton = ({
    policy,

    ...props
}) => {
    return (
        <PrintButton icon="file-alt" printAction={() => printPolicyAssignmentContract(policy.id)}
            viewUrl={getPolicyAssignmentContractUrl(policy.id)}
            downloadUrl={getPolicyAssignmentContractUrl(policy.id, true)} objId={policy.id}
            additional={'assignmentContract'} {...props} />
    );
};

PolicyAssignmentContractPrintButton.defaultProps = {
    label: 'Възлагателен договор',
    objType: 'policy',
};

PolicyAssignmentContractPrintButton.propTypes = {
    label: PropTypes.string,
    objType: PropTypes.string,
    policy: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default PolicyAssignmentContractPrintButton;
